import { createAction, props } from '@ngrx/store';
import {
  ClusterDto,
  GeoviewSummaryDto,
  PagedVehiclesDto,
  VehicleDetailByVinDto,
} from '@services/api/api.service';
import type { DealerGeoviewClusterTile } from './cluster-tiles';

export interface DealerGeoviewFilters {
  q?: string;
  dataTraffic?: string;
  vehicleStatus?: {
    star?: boolean;
    active?: boolean;
    alarm?: boolean;
    maintenance?: boolean;
  };
}

export interface DealerGeoviewViewport {
  minLatitude: number;
  maxLatitude: number;
  minLongitude: number;
  maxLongitude: number;
  zoomLevel: number;
}

export const setGeoviewDealerFilters = createAction(
  '[GeoviewDealer] setGeoviewDealerFilters',
  props<{ filters: DealerGeoviewFilters }>(),
);

export const setGeoviewDealerSelected = createAction(
  '[GeoviewDealer] setGeoviewDealerSelected',
  props<{ value: any; }>(),
);

export const getGeoviewDealerVehicles = createAction(
  '[GeoviewDealer] initialize',
  props<{ user_id: string }>(),
);

export const refreshGeoviewDealer = createAction(
  '[GeoviewDealer] refresh',
);

export const refreshGeoviewDealerVisibleClusterTiles = createAction(
  '[GeoviewDealer] refresh visible cluster tiles',
);

export const setGeoviewDealerAutomaticRefresh = createAction(
  '[GeoviewDealer] set automatic refresh',
  props<{ enabled: boolean }>(),
);

export const setGeoviewDealerWithoutPositionFilter = createAction(
  '[GeoviewDealer] set without position filter',
  props<{ enabled: boolean }>(),
);

export const loadGeoviewDealerSummary = createAction(
  '[GeoviewDealer] load summary',
);

export const loadGeoviewDealerSummarySuccess = createAction(
  '[GeoviewDealer] load summary success',
  props<{ summary: GeoviewSummaryDto }>(),
);

export const loadGeoviewDealerSummaryFailure = createAction(
  '[GeoviewDealer] load summary failure',
  props<{ error: unknown }>(),
);

export const setGeoviewDealerViewport = createAction(
  '[GeoviewDealer] set viewport',
  props<{ viewport: DealerGeoviewViewport }>(),
);

export const loadGeoviewDealerClusterTiles = createAction(
  '[GeoviewDealer] load cluster tiles',
  props<{ tiles: DealerGeoviewClusterTile[]; force?: boolean }>(),
);

export const geoviewDealerClusterTileRequestsStarted = createAction(
  '[GeoviewDealer] cluster tile requests started',
  props<{ tiles: DealerGeoviewClusterTile[] }>(),
);

export const loadGeoviewDealerClusterTileSuccess = createAction(
  '[GeoviewDealer] load cluster tile success',
  props<{ tile: DealerGeoviewClusterTile; clusters: ClusterDto[]; loadedAt: number }>(),
);

export const loadGeoviewDealerClusterTileFailure = createAction(
  '[GeoviewDealer] load cluster tile failure',
  props<{ tile: DealerGeoviewClusterTile; error: unknown }>(),
);

export const loadGeoviewDealerVehiclePage = createAction(
  '[GeoviewDealer] load vehicle page',
  props<{ pageNumber: number; pageSize: number; focusVin?: string }>(),
);

export const loadGeoviewDealerVehiclePageSuccess = createAction(
  '[GeoviewDealer] load vehicle page success',
  props<{ page: PagedVehiclesDto }>(),
);

export const loadGeoviewDealerVehiclePageFailure = createAction(
  '[GeoviewDealer] load vehicle page failure',
  props<{ error: unknown }>(),
);

export const loadGeoviewDealerVehicleByVin = createAction(
  '[GeoviewDealer] load vehicle by VIN',
  props<{ cluster: ClusterDto }>(),
);

export const loadGeoviewDealerVehicleByVinSuccess = createAction(
  '[GeoviewDealer] load vehicle by VIN success',
  props<{ cluster: ClusterDto; vehicle: VehicleDetailByVinDto }>(),
);

export const loadGeoviewDealerVehicleByVinFailure = createAction(
  '[GeoviewDealer] load vehicle by VIN failure',
  props<{ vin: string; error: unknown }>(),
);

export const setDealerVehicleFavorite = createAction(
  '[GeoviewDealer] setDealerVehicleFavorite',
  props<{ vin: string; isFavorite: boolean }>(),
);

export const dealerVehicleEngineStatusChanged = createAction(
  '[GeoviewDealer] dealerVehicleEngineStatusChanged',
  props<{ vin: string; engineOn: boolean }>(),
);

export const startPollingGeoviewDealer = createAction(
  '[GeoviewDealer] startPollingGeoviewDealer',
  props<{ userId: string }>(),
);

export const stopPollingGeoviewDealer = createAction(
  '[GeoviewDealer] stopPollingGeoviewDealer',
);

export const obtainGeoviewDealerJwt = createAction(
  '[GeoviewDealer] obtainGeoviewDealerJwt',
);
